<template>
    <div class="prdList clearfix">
        <a :href="prdUrl">
            <img :src="imgUrl | urlProtocol" alt="">
            <div class="intro">
                <h3>{{name}}</h3>
                <p class="price sale-price" v-if="sell">&yen;{{sell}}</p>
            </div>
        </a>
    </div>
</template>

<script>
    export default{
    	name: 'searchPro',
    	props: {
    		prdUrl:{
    			type: String
            },
            imgUrl: {
                type: String
            },
            name: {
                type: String
            },
            sell: {
    			type: String
            }
        }

    }
</script>

<style scoped>
    .prdList{
            img{
                float: left;
                width: 160px;
                height: 160px;
                border-radius: 2px;
                background:rgba(0,0,0,0.03);
            }
        .intro{
            float: right;
            width: 516px;
            h3{
                height: 92px;
                font-size: 32px;
                color: #222;
                letter-spacing:0;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            p{
                width: 146px;
                height: 37px;
                margin: 23px 0 0 0;
            }
            .price{
                font-size: 26px;
                color: #e21d1d;
                /*letter-spacing: 0.013rem;*/
            }
            .sell{
                font-size:26px;
                color:#999999;
                letter-spacing:0.65px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/commons/productList.vue